import type { SubscriptionMetadata } from '../services/stripeService';
import { getStoredUTMs } from './utm';
import { getStoredFbCookies } from '../components/funnelV3/analytics/funnelV3Analytics';

/** Keys written to Stripe Subscription + initial PaymentIntent at checkout. */
export const STRIPE_SUBSCRIPTION_CHECKOUT_KEYS = [
    'funnel_source',
    'ab_variant',
    'pricing_mode',
    'pricing_tier',
    'pricing_band',
    'cp_score',
    'vp_score',
    'predicted_ltv',
    'card_funding',
    'ltv_version',
    'fbp',
    'fbc',
    'tiktok_event_id',
    'ttclid',
    'pinterest_event_id',
] as const;

function pickStringMetadata(
    source: Record<string, string | undefined>,
    keys: readonly string[],
): Record<string, string> {
    const out: Record<string, string> = {};
    for (const key of keys) {
        const val = source[key];
        if (typeof val === 'string' && val.trim()) {
            out[key] = val.trim();
        }
    }
    return out;
}

/** Build the minimal Stripe checkout metadata payload from funnel payment context. */
export function buildStripeCheckoutMetadata(
    input: SubscriptionMetadata,
): Record<string, string> {
    const utms = getStoredUTMs();
    const fb = getStoredFbCookies();

    return pickStringMetadata(
        {
            ...input,
            ...(utms.utm_source && { utm_source: utms.utm_source }),
            ...(utms.utm_medium && { utm_medium: utms.utm_medium }),
            ...(utms.utm_campaign && { utm_campaign: utms.utm_campaign }),
            ...(utms.utm_content && { utm_content: utms.utm_content }),
            ...(utms.utm_term && { utm_term: utms.utm_term }),
            ...(fb.fbp && { fbp: fb.fbp }),
            ...(fb.fbc && { fbc: fb.fbc }),
        },
        STRIPE_SUBSCRIPTION_CHECKOUT_KEYS,
    );
}
